import React, { useContext, useState } from 'react'
import { Popover } from '../Popover/Popover'
import { SwapUsersSelect } from './SwapUsersSelect/SwapUsersSelect'
import styles from './View4.module.scss'
import { MainContext } from '../../../utils/context'
import { AudioComponent, VideoComponent } from '../../LivekitComponents/index'
import { Tooltip } from '../Tooltip/Tooltip'
import fullScreenIcon from '../../../img/icons/fullScreen.png'
import listIcon from '../../../img/icons/list.png'
import voiceActive from '../../../img/icons/voice-active.png'
import voiceNotActive from '../../../img/icons/voiceNotActive.png'

const EMPTY_LIST = new Array(7).fill(null)


export const View4 = () => {
  
  const {localParticipant, participants, toggleMuteParticipant, setFoolScreen} = useContext(MainContext)
  

  const renderUser = (_, ind) => {
    const userKey = Object.keys(participants)[ind]
    if (!userKey) return <div className={styles.user} />
    const userData = participants[userKey]
    return (
      <User
        key={userKey}
        {...userData}
        toggleMute={() => toggleMuteParticipant(userKey)}
        setFoolScreen={() => setFoolScreen(userData)}
      />
    )
  }


  return (
    <div className={styles.wrapper}>
      <div className={styles.mains}>

        <User {...localParticipant} local />
        {EMPTY_LIST.map(renderUser)}

      </div>
    </div>
  )
}

const User = ({
  userdata,
  audioTrack,
  videoTrack,
  screenShareTrack,
  isAudioEnabled,
  isVideoEnabled,
  local,
  toggleMute,
  setFoolScreen
}) => {
  
  const { username, organization, position } = userdata

  const [visiblePopover, setVisiblePopover] = useState(false)
  
  return (
    <Popover
      onHide={() => setVisiblePopover(false)}
      trigger='manual'
      visible={visiblePopover}
      content={<SwapUsersSelect /* users={usersForSelect} swapUsers={handleSwapUsers} */ />}
    >
    <div className={styles.user}>
      <VideoComponent track={videoTrack} local={local}/>
      {screenShareTrack &&
        <div className={styles.screenShareBlock}>
          <VideoComponent track={screenShareTrack} local={local}/>
        </div>
      }
      {!local && <AudioComponent track={audioTrack} muted={!isAudioEnabled}/>}
      <div className={styles.descriptionWrapper}>
        {!!username &&
          <div className={styles.descriptionMain}>
            <p>{username}</p>
            <p>{`${organization}, ${position}`}</p>
          </div>
        }
        {!local &&
          <div className={styles.iconsBlock}>
            <Tooltip content='на весь экран'>
              <img
                src={fullScreenIcon}
                alt='o_O'
                onClick={setFoolScreen}
              />
            </Tooltip>
            <Tooltip content='микрофон'>
              <img
                src={isAudioEnabled ? voiceActive : voiceNotActive}
                alt='o_O'
                onClick={toggleMute}
              />
            </Tooltip>
            <Tooltip content='заменить участника'>
              <img
                src={listIcon}
                alt='o_O'
                onClick={() => setVisiblePopover(true)}
              />
            </Tooltip>
          </div>
        }
      </div>
    </div>
  </Popover>
  )
}